<script>

import {  mapGetters, mapMutations, mapActions } from 'vuex';
import draggable from 'vuedraggable'
import StatusLaneItem from './status-lane-item.vue'
import Swal from 'sweetalert2'
import { throttle } from "lodash";
import { isCustomFieldEmpty } from '@/helpers'

export default {
  components: {
    draggable,
   StatusLaneItem
  },
  props: {
    directory: {
      type: Object,
      required: true
    },
    status: {
      type: Object,
      required: true
    },
    orderByField: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      dragged: null,
      draggedIndex: null
    };
  },
  computed : {
    
    ...mapGetters('directoryItems', {
      allItems: 'itemsData',
      persistentData: 'persistentData'
    }),
    isMobile() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ];
      console.log('navigator.userAgent', navigator.userAgent);
      return toMatch.some((toMatchItem) => {
          return navigator.userAgent.match(toMatchItem);
      })
    },
    dirItems() {
      return this.allItems[this.directory.id] || { board: { statusItems: {} }};
    },
    statusItems() {
      return (this.dirItems.board.statusItems || {})[this.status.id] || { total: 0, items: []};
    },
    total () {
      return this.statusItems.total || 0;
    },
    items:  {
      get: function() {
        return this.statusItems.items || [];
      },
      set: async function(newValue) {
        this.updateItems(newValue);          
      }
    }
  },
  
  methods:{
    ...mapMutations('directoryItems', {
       updateStatusItems: 'UPDATE_STATUS_ITEMS'
    }),
    ...mapActions('directoryItems', {
       move: 'move',
       more: 'more',
       load: 'load'
    }),
    scrollX: throttle(function({scrollableElement, scrollTo}){
      scrollableElement.scrollLeft = scrollTo;
    }, 500),
    scrollY: throttle(function({scrollableElement, scrollTo}){
       scrollableElement.scrollTop = scrollTo;
    }, 500),
    onDrag(/*evt*/) {
    
      // const scrollableElement = this.scrollableElement;
      // const draggedItem = this.draggedItem;
      // if(scrollableElement && draggedItem) {
      //   const scrollTop  = scrollableElement.scrollTop ;
      //   const scrollableElementHeight = scrollableElement.offsetHeight;
      //   const draggedItemHeight = draggedItem.offsetHeight;
      //   const yDiff = evt.clientY -  this.originalMousePosY;

      //   if(yDiff > 10) {
      //     const potentialEnd = draggedItemHeight + evt.clientY;
      //     if(potentialEnd > scrollableElementHeight) {
      //       const scrollTo = scrollTop + (potentialEnd - scrollableElementHeight);
      //       if(this.scrollToY !== scrollTo) {
      //         this.scrollToY = scrollTo;
      //         this.scrollY( {scrollableElement, scrollTo} );
      //       }
      //     }
      //   } else  if(yDiff < 10) {
         
      //     if(scrollTop > 0) {
      //       const potentialEnd = evt.clientY - 300;
      //       if(potentialEnd < 100) { // header ofn table
      //         const scrollTo = scrollTop + potentialEnd;
      //         if(this.scrollToY !== scrollTo) {
      //           this.scrollToY = scrollTo;
      //           this.scrollY( {scrollableElement, scrollTo} );
      //         }
      //       }
      //     }
      //   }

      //   const scrollLeft  = scrollableElement.scrollLeft ;
      //   const scrollableElementWidth = scrollableElement.offsetWidth;
      //   //const scrollWidth = scrollableElement.scrollWidth;
      //   const draggedItemWidth = draggedItem.offsetWidth;
      //   const xDiff = evt.clientX -  this.originalMousePosX;
       
      //   if(xDiff > 10) {
      //      const potentialEnd = draggedItemWidth + evt.clientX;
      //      if(potentialEnd > scrollableElementWidth) {
      //         const scrollTo = scrollLeft + (potentialEnd - scrollableElementWidth);
      //         if(this.scrollToX !== scrollTo) {
      //           this.scrollToX = scrollTo;
      //           this.scrollX( {scrollableElement, scrollTo} );
      //         }
      //       }
      //   } else if(xDiff < 10) {
            
      //     if(scrollLeft > 0) {
      //       const potentialEnd = evt.clientX - draggedItemWidth;
      //       if(potentialEnd < 100) {
      //          //console.log('scroll left', potentialEnd);
      //         const scrollTo = scrollLeft - potentialEnd;
      //         if(this.scrollToX !== scrollTo) {
      //           this.scrollToX = scrollTo;
      //           this.scrollX( {scrollableElement, scrollTo} );
      //         }
      //       }
      //     }
      //   }
      // }
    },
    onStart(evt) {
    
      this.dragged = this.items[evt.oldIndex];
      this.draggedIndex = evt.oldIndex;

      const from = evt.from;
      let scrollableElement = from.parentElement;

      while(scrollableElement ){
        if(scrollableElement.classList.contains("board-scrolable-container")) {
          break;
        }
        scrollableElement = scrollableElement.parentElement;
      }
      // if(scrollableElement) {
      //   this.originalMousePosX = evt.originalEvent.clientX;
      //   this.originalMousePosY = evt.originalEvent.clientY;
      //   this.scrollableElement = scrollableElement;
      //   this.scrollToX = null;
      //   this.scrollToY = null;
      //   this.draggedItem = evt.item;
      //   scrollableElement.addEventListener('drag', this.onDrag);  
      // }
    },
    onEnd() {

      this.dragged = null;
      this.draggedIndex = null;

      // if(this.scrollableElement) {
      //   this.scrollableElement.removeEventListener('drag', this.onDrag);
      //   this.scrollableElement = null;
      //   this.draggedItem = null;
      // }
    },
    async updateItems(newValue){
      const oldValue = this.items;

      if(this.orderByField !== '$$status-pos$$' && oldValue.length === newValue.length) {
        return;
      }

      if(oldValue.length > newValue.length) {
        
        this.updateStatusItems({ directoryId: this.directory.id, status: this.status.id, items: newValue, total: this.total - 1});
        return;
      }

      let prev = null;
      let item = this.dragged;
      if(newValue.length > oldValue.length) {
      
        let o = new Set(oldValue);
        item = newValue.find(x => !o.has(x));
        if(item) {
          const pos = newValue.indexOf(item);
          if(pos > 0 ) {
            prev = newValue[pos-1];
          }
        }
      } else {
        const newIndex = newValue.indexOf(this.dragged);
        const oldIndex = oldValue.indexOf(this.dragged);
        if(newIndex <= oldIndex) {
          const olditem = newIndex > 0 ? oldValue[newIndex-1] : null;
          prev = olditem;
        }else {
          const olditem = newIndex > 0 ? oldValue[newIndex] : null;
          prev = olditem;
        }
      }

      if(item) {
       
        var prevStatus = this.directory.statusList.find(x => x.id === item.status);
        var nextStatus =  this.status;

        var statusRequiredFields = nextStatus.fields.filter(x => x.required);
        let allow = true;
        statusRequiredFields.forEach(async reqField  => {
          if(!allow) return;

          const fieldDef = this.directory.fields.find(x => x.id === reqField.field);
          if(!fieldDef) return;

          const f = item.customFields[reqField.field];
          if(!f || isCustomFieldEmpty(f)) {
            console.log('req ', {fieldDef, f,item });
            Swal.fire({
              text: this.$t('common.field') + ' ' + fieldDef.name + ' ' + this.$t('common.isRequired'),
              icon: "warning",
            });
            allow = false;
            return;
          }
        });

        if(!allow) {
          this.load({directoryId: this.directory.id});
          return;
        }

        var noteRequired = false;
        if(this.directory.commentsEnabled && (prevStatus.requiredCommentToLeave || nextStatus.requiredCommentToEnter)) {
          noteRequired = true;
        }
        this.updateStatusItems({ directoryId: this.directory.id, status: this.status.id, items: newValue, total: this.total + 1});
        let note = null;
        if(noteRequired) {
          const { value } = await Swal.fire({
            title: this.$t('common.commentRequired'),
            input: 'text',
            inputLabel: this.$t('common.pleaseWriteComment'),
            inputValue: '',
            showCancelButton: true,
            inputValidator: (value) => {
              if (!value) {
                return this.$t('common.youNeedToWriteSomething')
              }
            }
          });
          note = value;
        }
       
        if (note || !noteRequired) {
          this.move({directoryId: this.directory.id, prevId: (prev || {}).id, itemId: item.id, status: this.status.id, ignorePosition: this.orderByField !== '$$status-pos$$',  note});
        } else {
          this.load({directoryId: this.directory.id});
        }
      }
    }
  }
};
</script>

<style scoped>
.status {
  min-width: 300px;
  width: 200px;
  max-width: 300px; 
  
}
.status.body {
  border-top: 3px solid white;
  border-bottom: 3px solid white;
  border-right: 3px solid white;

  min-height: 300px;
 
}

.status.body.default {
   min-height: 300px;
   
}

.status.body.user-defined {
  position: relative;
}

.status.body:first-child {
  border-left: 3px solid white;
}

.list-container {
  min-height: 300px;
}


table.board-table > tbody > tr > td {
  vertical-align: top;
}
  
</style>

<template>

  <draggable 
    v-model="items" 
    tag="td" 
    item-key="index" 
    group="processes" 
    @start="onStart" 
    @end="onEnd" 
    handle=".drag-area"
    :delay="isMobile ? 400 : 0"
    class="status body bg-light text-center"
  >
    <template  #header>
     
    </template>
    
    <template #item="{element}">
      <status-lane-item 
      :selected-item-id="dragged ? dragged.id : null"
      :item="element" :directory="directory" :status="status">
      </status-lane-item>
    </template>

    <template  #footer>
      <div v-if="total > items.length" class="btn btn-link d-block" @click="more({directoryId: directory.id, status: status.id})">
        <i class="mdi-chevron-double-down mdi font-size-20"></i>
      </div>
     
    </template>
  </draggable>
</template>
